// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vision{
    width: 100%;  
    height: 70vh;
background-color: #edffff;
}
.innerVision
{
    width: 60%;
    margin-left: 15%;
    text-align: left;
}
.mainHeading
{
    font-family: 'VanillaMilk';
    font-size: 60px;
    color: #8b0194;
    text-align: center;
    z-index: 1;
    padding: 20px;
}
.subHeading
{
    font-family:sans-serif;
    font-size: 30px;
    font-weight: bold;

    color: #8b0194; 
    z-index: 1; 
}
.para
{
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size:18px; 
    text-align: left;
    color: #0e0e0e; 
    z-index: 1; 
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/FooterPages/ourVision.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB,yBAAyB;AACzB;AACA;;IAEI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;AACA;;IAEI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,UAAU;AACd;AACA;;IAEI,2DAA2D;IAC3D,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,UAAU;AACd","sourcesContent":[".vision{\n    width: 100%;  \n    height: 70vh;\nbackground-color: #edffff;\n}\n.innerVision\n{\n    width: 60%;\n    margin-left: 15%;\n    text-align: left;\n}\n.mainHeading\n{\n    font-family: 'VanillaMilk';\n    font-size: 60px;\n    color: #8b0194;\n    text-align: center;\n    z-index: 1;\n    padding: 20px;\n}\n.subHeading\n{\n    font-family:sans-serif;\n    font-size: 30px;\n    font-weight: bold;\n\n    color: #8b0194; \n    z-index: 1; \n}\n.para\n{\n    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-size:18px; \n    text-align: left;\n    color: #0e0e0e; \n    z-index: 1; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
